import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { SelectBox } from '@tecuity/granite-ui'
import { setMiscRecordsSelectedModule } from '../../actions'

const MiscRecordsModuleDropdown = ({ modules, sourceTypeParam, showLabel = true }) => {
  const dispatch = useDispatch()
  const selectedModuleId = useSelector(
    (state) => state.app.miscRecordsSelectedModules[sourceTypeParam] || '',
  )

  useEffect(() => {
    if (!selectedModuleId && modules.length > 0) {
      dispatch(setMiscRecordsSelectedModule(sourceTypeParam, modules[0].MiscellaneousModuleId))
    }
  }, [selectedModuleId, modules, sourceTypeParam])

  if (modules.length <= 1) return null
  return (
    <SelectBox
      label={showLabel ? 'Module' : ''}
      options={(modules || []).map((m) => ({
        value: m.MiscellaneousModuleId,
        label: m.DisplayName,
      }))}
      value={selectedModuleId}
      onChange={(val) => dispatch(setMiscRecordsSelectedModule(sourceTypeParam, val))}
      noPlaceholder
    />
  )
}

export default MiscRecordsModuleDropdown
